import {AxiosError, AxiosResponse, AxiosInstance} from "axios";
import {panelBackUrl} from "./config";
import store from "@/store";
function wrapNullValue(value: any, msg = "Неизвестно") {
  return [null, undefined].includes(value) ? msg : value;
}

function emptySearchFilters() {
  return {
    online: false,
    terminalIds: null,
    terminalMacs: null,
    terminalIP: null,
    memoryFrom: null,
    memoryTo: null,
    template: null,
    vendor: null,
    model: null,
    distributionType: null,
    distributionBuild: null,
    displayNumber: null,
    displayResolution: null,
    transportAgent: null,
    transportAgentState: null,
  };
}

// validates aither teminas input string (1,2,3,1200) has valid format
function isValidTerminalCommaInput(teminasStr: String) {
  if (teminasStr) {
    for (const el of teminasStr.replace(/(^,)|(,$)/g, "").split(",")) {
      if (Number.isNaN(Number(el.trim()))) {
        return false;
      }
    }
  }
  return true;
}

function downloadObject(obj: any, name: String) {
  const dataStr =
    "data:text/json;charset=utf-8," +
    encodeURIComponent(JSON.stringify(obj, null, 2));
  const downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", `${name}_export` + ".json");
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

function paramObjectToUrlQueryStr(obj: Object) {
  /* eslint-disable no-unused-vars */
  return new URLSearchParams(
    Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null))
  ).toString();
}

async function getUserInfo(http: AxiosInstance) {
  await http
      .get(`${panelBackUrl}/v1/user`)
      .then(async (res: AxiosResponse) => {
        await store.dispatch("SAVE_USER_DATA", {
          fullName: res.data.name,
          login: res.data.login,
          settings: res.data.settings,
        });
      })
      .catch((error: AxiosError) => {
        console.log("Error to get user info", error);
      });
}

async function AddSSHPubKey(http: AxiosInstance, http_task: AxiosInstance, pubKey: string, terminalId: number): Promise<string | undefined> {
  return await http
      .post(`${panelBackUrl}/v1/proxy/api`, {
        url: `/v2/terminal/sshkey`,
        method: "POST",
        payload: {
          "terminalId": terminalId,
          "pubKey": pubKey,
        },
        headers: {},
      })
      .then(async (response: AxiosResponse) => {
        console.log(
            "Response from proxy api obtained (add pubkey data task). TaskId:",
            response.data.payload.taskId,
            response,
        );
        return await http_task
            .post(`${panelBackUrl}/v1/proxy/api`, {
              url: `/v2/task?taskId=${response.data.payload.taskId}`,
              method: "GET",
              payload: {},
              headers: {},
            })
            .then((taskResponse) => {
              console.log(
                  `Response for taskId: ${response.data.payload.taskId} obtained. State ${taskResponse.data.payload.taskState}`,
              );
              if (taskResponse.data.statusCode === 200) {
                console.log("Successfully added ssh key", taskResponse);
                return;
              }
              return undefined
            })
            .catch((error: AxiosError) => {
              console.log("Error to add ssh key", error);
              if (error.request.status === 403) {
                return "Недостаточно прав";
              }
              return JSON.stringify((error as any).data);
            });
      })
      .catch((error: AxiosError) => {
        console.log("Error to add ssh key", error);
        if (error.request.status === 403) {
          return "Недостаточно прав";
        }
        return JSON.stringify((error as any).data);
      });
}


export {
  wrapNullValue,
  emptySearchFilters,
  isValidTerminalCommaInput,
  downloadObject,
  paramObjectToUrlQueryStr,
  getUserInfo,
  AddSSHPubKey
};
